import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import "./addreco.css";

function AddReco({ id }) {

    const [inputNombre, setInputNombre]                 = useState("");
    
    const [image, setImage]                             = useState({ preview: '', data: '' })
    const [showAlert, setShowAlert]                     = useState(false);
    const [guardando, setGuardando]                     = useState(false);


    const handleSubmit = async (event) => {
        
        event.preventDefault();

        setGuardando(true);

        if( inputNombre && image ){
          
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            var vuelto = {
                "tag": inputNombre,
                "file": image
            }
          
            await fetch("../api/add-foto/"+id, {
                method: "POST",
                body: JSON.stringify(vuelto),
                headers: {'Content-Type':'application/json','Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                if(response.status === 200)
                    setShowAlert(true);
                    setImage({ preview: '', data: '' })
                    setInputNombre("");
                    setGuardando(false);
              })
              .catch(function (error) {
                console.log(error);
              });
        
        }
        else{
            alert("Faltan Datos, por favor complete el formulario");
            setGuardando(false);
        }

    };


    // const getBase64 = file => {
    //     return new Promise(resolve => {
    //       let fileInfo;
    //       let baseURL = "";
    //       // Make new FileReader
    //       let reader = new FileReader();
    
    //       // Convert the file to base64 text
    //       reader.readAsDataURL(file);
    
    //       // on reader load somthing...
    //       reader.onload = () => {
    //         // Make a fileInfo Object
    //         console.log("Called", reader);
    //         baseURL = reader.result;
    //         console.log(baseURL);
    //         resolve(baseURL);
    //       };
    //       console.log(fileInfo);
    //     });
    //   };

    
    const handleFileChange = e => {
        const files = e.target.files;
        const file = files[0];
        getBase64(file);
    }

    const onLoad = fileString => {
        setImage(fileString);
      };

    const getBase64 = file => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          onLoad(reader.result);
        };
      };

  return (
        <>
            <Container>

                <Alert className="mt-4" key="success" variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    Se guardó exitosamente la información.
                </Alert>

                <Row className="justify-content-md-center mt-4">
                    <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label htmlFor="input_nombre">Nombre de la persona</Form.Label>
                                <Form.Control 
                                id="input_nombre"
                                type="text" 
                                placeholder="Nombre de la persona"
                                defaultValue={inputNombre}
                                onKeyUp={(e) => setInputNombre(e.target.value)}
                                required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label htmlFor="input_foto">Foto</Form.Label>
                                <Form.Control 
                                id="input_foto"
                                type="file" 
                                placeholder="Foto"
                                onChange={handleFileChange}
                                required />
                                {/* <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                                </Form.Text> */}
                        </Form.Group>
                        
                        {!guardando ? (
                            <Button variant="primary" type="submit" onClick={(handleSubmit)}>
                                Guardar
                            </Button>
                        ) : (
                            <Button variant="primary" type="submit" disabled>
                                Guardando...
                            </Button>
                        )}
                        
                    </Col>
                </Row>
                
                
            </Container>
        </>
  )
}

export default AddReco;